import { render } from "./PaginatedList.vue?vue&type=template&id=1c2d54c0"
import script from "./PaginatedList.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginatedList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PaginatedList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c2d54c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c2d54c0', __exports__)) {
    api.reload('1c2d54c0', __exports__)
  }
  
  module.hot.accept("./PaginatedList.vue?vue&type=template&id=1c2d54c0", () => {
    api.rerender('1c2d54c0', render)
  })

}


export default __exports__